export default __webpack_public_path__ + "static/media/ColorCars_06.94ee6e4e.png";